import { useEffect, useState } from "react";
import ImageAttachmentTile from "components/Attachments/ImageAttachmentTile";
import { isPreviewableImage } from "utils/attachmentPreview";

/**
 * One attachment: a thumbnail with a large preview when it is an image, otherwise whatever
 * `renderFile(url)` returns (the caller's own name link). An image that fails to load, for example
 * an expired link, falls back to `renderFile` so the attachment stays reachable.
 */
const AttachmentItem = ({ url, contentType, onRemove, renderFile }) => {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [url]);

  if (isPreviewableImage(url, contentType) && !broken) {
    return <ImageAttachmentTile url={url} onRemove={onRemove} onError={() => setBroken(true)} />;
  }
  return renderFile(url);
};

export default AttachmentItem;
